import axios from "../axiosInstance";
import { CancelBatchResponse } from "./types";

export const cancelBatch = async (
  batchId: number,
): Promise<CancelBatchResponse> => {
  const response = await axios.patch<CancelBatchResponse>(
    `/api/private/batch/cancel/${batchId}`,
  );

  return response.data;
};
